import { Link } from "react-router-dom";
import { BananaCollections } from "../components/BananaCollections";

const BananaStandPage = () => (
  <>
    <title>Meet the Bananas | Tuttobanana</title>
    <meta name="description" content="Meet the Tuttobanana characters, then choose one to send privately for free." />
    <div className="bg-gray-100 px-4 py-12 text-gray-900 sm:px-12 sm:py-16">
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-bold uppercase tracking-[0.22em] text-yellow-600">Meet the bananas</p>
          <h1 className="mt-3 text-4xl font-black sm:text-5xl">Pick a feeling. Send it free.</h1>
          <p className="mt-4 text-base text-gray-600 sm:text-lg">Choose a banana, write something meaningful, and share it privately.</p>
          <Link to="/tuttobanana" className="mt-7 inline-flex rounded-full bg-yellow-400 px-7 py-3 font-bold text-gray-900 shadow hover:bg-yellow-300">
            Toss a Banana — It&apos;s Free →
          </Link>
        </div>
        <section className="mx-auto mt-10 max-w-4xl sm:mt-12">
          <BananaCollections />
        </section>
      </div>
    </div>
  </>
);

export default BananaStandPage;
